<template>

  <AbortStateTemplate
      :headline="headline"
      :image-src="abortImage"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

<script>
import teaserCardsData from "@/data/teaserData";
import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";
import abortImage from '../../assets/icons/Deutschlandkarte.png';

export default {
  name: 'StateAbortZipCode',
  components: {
    AbortStateTemplate,
  },
  data() {
    return {
      abortImage,
      headline:
      "Vielen Dank für Ihr Interesse. Leider können wir aktuell kein passendes Angebot für das Haus erstellen.",
      abortMessage:
          "Für Ihre Postleitzahl können wir Ihnen leider noch kein Angebot bereitstellen. " +
          "Wir bauen unser Fachpartnernetz kontinuierlich aus. Schauen Sie gern zu einem späteren Zeitpunkt wieder bei uns vorbei.",
      teaserCardsData
    };
  },
}
</script>

<style scoped>

</style>
